import React, { Component , Fragment } from "react";
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

class CounterOne extends Component{
    state = {
        didViewCountUp: false
    };
    onVisibilityChange = isVisible => {
        if (isVisible) {
            this.setState({didViewCountUp: true});
        }
    }
    render(){
        let Data = [
            {
                countImg:<img src="assets/images/bg/computerSoluction.webp" alt="Plugify Gali" style={{height:140, margin:20}} />,   
                suffix: "-",
                countNum : 10,
                countTitle: 'Cliques para realizar um pedido',
                useEasing : true,
                duration: 8,
            }, 
            { 
                countImg:<img src="assets/images/bg/globo2a.webp" alt="Plugify Gali" style={{height:140, margin:20}} />,
                suffix: "+",
                countNum : 12,
                countTitle: 'Voltas ao mundo percorridas com entregas de dispositivos',
                 useEasing : true,
                duration: 8,
            },

            {
                countImg:<img src="assets/images/bg/brasil.webp" alt="Plugify Gali" style={{height:140, margin:20}} />,   
                suffix: "+",
                countNum : 25,
                countTitle: 'Estados brasileiros em que estamos presentes',
                useEasing : true,
                duration: 8,
            }

            
        ];

        return(
            <Fragment>
                <div className="row">
                    {Data.map( (value, index) => (
                        <div className="im_single_counterup col-lg-4 col-md-4 col-sm-6 col-12" key={index}>
                            <div className="im_counterup">
                                <div className="inner">
                                    <div className="iconCounter">
                                        {value.countImg}
                                    </div>
                                    <h2 className="counter">
                                        <VisibilitySensor onChange={this.onVisibilityChange} offset={{top:10}} delayedCall>
                                            <CountUp end={this.state.didViewCountUp ? value.countNum : 0} suffix={value.suffix} />
                                            </VisibilitySensor>
                                    </h2>
                                    <p className="descriptionCounter" style={{color:'#fff', paddingTop: 20}}>{value.countTitle}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Fragment>
        )
    }
}
export default CounterOne;